/**
 * Molecule ED Assessment — UI primitives (Figma 1598:12972)
 * Exposed as window.WmEdAssessmentUI
 */
(function (global) {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var ARROW_LEFT =
    '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect width="28" height="28" rx="14" fill="#219C87"/>' +
    '<path d="M12.4056 18.4756C12.2809 18.4756 12.1563 18.4297 12.0578 18.3312L8.07438 14.3478C7.88406 14.1575 7.88406 13.8425 8.07438 13.6522L12.0578 9.66874C12.2481 9.47842 12.5631 9.47842 12.7534 9.66874C12.9438 9.85905 12.9438 10.174 12.7534 10.3644L9.11781 14L12.7534 17.6356C12.9438 17.8259 12.9438 18.1409 12.7534 18.3312C12.6616 18.4297 12.5303 18.4756 12.4056 18.4756Z" fill="#F1F8FE"/>' +
    '<path d="M19.5779 14.4922H8.5332C8.26414 14.4922 8.04102 14.2691 8.04102 14C8.04102 13.7309 8.26414 13.5078 8.5332 13.5078H19.5779C19.847 13.5078 20.0701 13.7309 20.0701 14C20.0701 14.2691 19.847 14.4922 19.5779 14.4922Z" fill="#F1F8FE"/>' +
    '</svg>';

  function progress(pct) {
    var n = Math.max(0, Math.min(100, Math.round(Number(pct) || 0)));
    return (
      '<div class="wmaed__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      n +
      '" aria-label="Assessment progress">' +
      '<p class="wmaed__progress-pct">' +
      n +
      '%</p>' +
      '<div class="wmaed__progress-track">' +
      '<div class="wmaed__progress-fill' +
      (n > 0 ? ' is-active' : '') +
      '" style="width:' +
      n +
      '%"></div></div>' +
      '</div>'
    );
  }

  function backButton() {
    return (
      '<button type="button" class="wmaed__back" data-action="back">' +
      ARROW_LEFT +
      '<span>Back</span></button>'
    );
  }

  function primaryButton(label, action, opts) {
    opts = opts || {};
    var cls = 'wmaed__btn';
    if (opts.tall) cls += ' wmaed__btn--tall';
    if (opts.disabled) cls += ' is-disabled';
    return (
      '<button type="button" class="' +
      cls +
      '"' +
      (action ? ' data-action="' + esc(action) + '"' : '') +
      (opts.disabled ? ' disabled aria-disabled="true"' : '') +
      '>' +
      '<span>' +
      esc(label || 'Continue') +
      '</span></button>'
    );
  }

  function heading(text, htmlAllowed) {
    if (htmlAllowed) {
      return '<h1 class="wmaed__heading">' + text + '</h1>';
    }
    return '<h1 class="wmaed__heading">' + esc(text) + '</h1>';
  }

  function hint(text) {
    return text ? '<p class="wmaed__hint">' + esc(text) + '</p>' : '';
  }

  function body(text) {
    return text ? '<p class="wmaed__body">' + esc(text) + '</p>' : '';
  }

  function alert(message, type) {
    if (!message) return '';
    var kind = type === 'success' ? 'success' : type === 'info' ? 'info' : 'error';
    return (
      '<p class="wmaed__alert wmaed__alert--' +
      kind +
      '" role="alert">' +
      esc(message) +
      '</p>'
    );
  }

  function optionCards(q, value, multi) {
    var selected = multi
      ? Array.isArray(value)
        ? value
        : []
      : value
        ? [value]
        : [];
    var name = esc(q.apiKey || q.field || q.id);
    var type = multi ? 'checkbox' : 'radio';
    var labelId = 'wmaed-legend-' + name;
    var html =
      '<fieldset class="wmaed__fieldset" aria-labelledby="' +
      labelId +
      '">' +
      '<div id="' +
      labelId +
      '" class="wmaed__legend">' +
      (q.headingHtml || esc(q.heading)) +
      '</div>';
    if (q.hint) html += hint(q.hint);
    html += '<div class="wmaed__options" role="group">';
    (q.options || []).forEach(function (opt) {
      var isOn = selected.indexOf(opt.value) !== -1;
      html +=
        '<label class="wmaed__option' +
        (isOn ? ' is-selected' : '') +
        '" data-option-field="' +
        name +
        '" data-option-value="' +
        esc(opt.value) +
        '"' +
        (multi ? ' data-option-multi="1"' : '') +
        '>' +
        '<input type="' +
        type +
        '" name="' +
        name +
        '" value="' +
        esc(opt.value) +
        '"' +
        (isOn ? ' checked' : '') +
        ' data-field="' +
        name +
        '"' +
        (multi ? ' data-multi="1"' : '') +
        ' tabindex="-1">' +
        '<span class="wmaed__option-label">' +
        esc(opt.label) +
        '</span>';
      if (opt.description) {
        html += '<span class="wmaed__option-desc">' + esc(opt.description) + '</span>';
      }
      html += '</label>';
      if (q.otherValue && opt.value === q.otherValue && isOn) {
        html +=
          '<span class="wmaed__input-shell">' +
          '<input class="wmaed__input-pill" type="text" data-other-key="' +
          esc(q.otherApiKey || name + '_other') +
          '" placeholder="' +
          esc(q.otherPlaceholder || 'Please specify') +
          '" value="' +
          esc(q._otherValue || '') +
          '" aria-label="' +
          esc(q.otherPlaceholder || 'Please specify') +
          '"></span>';
      }
    });
    html += '</div></fieldset>';
    return html;
  }

  function confirmToggle(id, checked, label) {
    return (
      '<label class="wmaed__confirm' +
      (checked ? ' is-checked' : '') +
      '">' +
      '<input type="checkbox" data-field="' +
      esc(id) +
      '" data-confirm="1"' +
      (checked ? ' checked' : '') +
      '>' +
      '<span class="wmaed__confirm-box" aria-hidden="true"></span>' +
      '<span class="wmaed__confirm-text">' +
      esc(label) +
      '</span></label>'
    );
  }

  function infoAck(page, answers) {
    answers = answers || {};
    var key = page.apiKey || page.field;
    var checked = !!answers[key];
    return (
      heading(page.heading) +
      body(page.body) +
      confirmToggle(key, checked, page.confirmLabel || 'I understand') +
      primaryButton(page.nextLabel || 'Continue', 'next', {
        disabled: !checked,
        tall: true
      })
    );
  }

  function dualConfirm(page, answers) {
    answers = answers || {};
    var checks = page.checkboxes || [];
    var html =
      heading(page.heading) +
      (page.body ? '<p class="wmaed__consent-body">' + esc(page.body) + '</p>' : '') +
      '<div class="wmaed__confirm-stack">';
    var allOn = true;
    checks.forEach(function (c) {
      var key = c.apiKey || c.field;
      var on = !!answers[key];
      if (!on) allOn = false;
      html += confirmToggle(key, on, c.label);
    });
    html += '</div>';
    html += primaryButton(page.nextLabel || 'Continue', 'next', {
      disabled: !allOn,
      tall: true
    });
    return html;
  }

  function textField(opts) {
    opts = opts || {};
    var labelHtml = '';
    if (opts.fieldLabel) {
      labelHtml =
        '<span class="wmaed__field-label">' +
        esc(opts.fieldLabel) +
        (opts.required ? ' <span class="wmaed__req" aria-hidden="true">*</span>' : '') +
        '</span>';
    }
    return (
      '<label class="wmaed__fieldset' +
      (opts.className ? ' ' + esc(opts.className) : '') +
      '">' +
      labelHtml +
      '<span class="wmaed__input-shell">' +
      '<input class="wmaed__input-pill" type="' +
      esc(opts.type || 'text') +
      '" data-field="' +
      esc(opts.id) +
      '" placeholder="' +
      esc(opts.placeholder || '') +
      '" value="' +
      esc(opts.value || '') +
      '"' +
      (opts.autocomplete ? ' autocomplete="' + esc(opts.autocomplete) + '"' : '') +
      (opts.inputmode ? ' inputmode="' + esc(opts.inputmode) + '"' : '') +
      (opts.required ? ' required aria-required="true"' : '') +
      ' aria-label="' +
      esc(opts.ariaLabel || opts.fieldLabel || opts.placeholder || opts.id) +
      '">' +
      '</span></label>'
    );
  }

  function detailsFields(answers) {
    answers = answers || {};
    return (
      '<div class="wmaed__details">' +
      '<div class="wmaed__details-row">' +
      textField({
        id: 'first_name',
        fieldLabel: 'First Name',
        placeholder: 'First Name',
        value: answers.first_name || '',
        autocomplete: 'given-name',
        required: true,
        className: 'wmaed__fieldset--half'
      }) +
      textField({
        id: 'last_name',
        fieldLabel: 'Last Name',
        placeholder: 'Last Name',
        value: answers.last_name || '',
        autocomplete: 'family-name',
        required: true,
        className: 'wmaed__fieldset--half'
      }) +
      '</div>' +
      textField({
        id: 'phone',
        type: 'tel',
        fieldLabel: 'Phone Number',
        placeholder: 'Phone Number',
        value: answers.phone || '',
        autocomplete: 'tel',
        inputmode: 'tel',
        required: true
      }) +
      textField({
        id: 'email',
        type: 'email',
        fieldLabel: 'Email Address',
        placeholder: 'Email Address',
        value: answers.email || '',
        autocomplete: 'email',
        required: true
      }) +
      '</div>'
    );
  }

  function details(page, answers, opts) {
    opts = opts || {};
    return (
      heading(page.heading || 'Please enter your details') +
      detailsFields(answers) +
      primaryButton(page.nextLabel || 'Continue', 'next', {
        disabled: !!opts.disabled
      })
    );
  }

  function intro(page) {
    return (
      '<div class="wmaed__intro-block">' +
      heading(page.heading) +
      (page.body ? body(page.body) : '') +
      primaryButton(page.nextLabel || 'Continue', 'next') +
      '</div>'
    );
  }

  function kickoutScreen(page) {
    page = page || {};
    var actions = page.actions || [
      {
        label: page.nextLabel || 'Book a Clinician Review',
        action: page.nextAction || 'book-clinician'
      }
    ];
    var centerClass = page.textAlign === 'center' ? ' wmaed__kickout--center' : '';
    var html =
      '<div class="wmaed__kickout' +
      centerClass +
      '" role="status">' +
      '<div class="wmaed__kickout-card">' +
      '<h1 class="wmaed__heading">' +
      esc(page.heading || '') +
      '</h1>' +
      (page.body ? '<p class="wmaed__body">' + esc(page.body) + '</p>' : '') +
      '</div>' +
      '<div class="wmaed__kickout-actions">';
    actions.forEach(function (a) {
      html += primaryButton(a.label, a.action, { tall: true });
    });
    html += '</div></div>';
    return html;
  }

  function shell(opts) {
    opts = opts || {};
    var slideClass = opts.animate ? ' wmaed__slide-enter' : '';
    if (opts.hideChrome) {
      return (
        '<div class="wmaed__shell wmaed__shell--bare">' +
        '<div class="wmaed__content' +
        slideClass +
        '" data-slide>' +
        (opts.inner || '') +
        '</div></div>'
      );
    }
    return (
      '<div class="wmaed__shell">' +
      progress(opts.progress) +
      '<div class="wmaed__content' +
      slideClass +
      '" data-slide>' +
      (opts.showBack ? backButton() : '') +
      (opts.inner || '') +
      '</div></div>'
    );
  }

  global.WmEdAssessmentUI = {
    esc: esc,
    progress: progress,
    backButton: backButton,
    primaryButton: primaryButton,
    heading: heading,
    hint: hint,
    body: body,
    alert: alert,
    optionCards: optionCards,
    confirmToggle: confirmToggle,
    infoAck: infoAck,
    dualConfirm: dualConfirm,
    intro: intro,
    details: details,
    detailsFields: detailsFields,
    kickoutScreen: kickoutScreen,
    shell: shell
  };
})(window);
